import { createAction, createReducer } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

export interface MessageData {
    body: string;
    title: string;
    duration?: number;
    dismissable?: boolean;
}

const defaultMessageData = {
    duration: 5000,
    dismissable: true
} as MessageData

export interface Message extends MessageData {
    uuid: string;
}

const initialState: { messages: Message[] } = { messages: [] };

export const messageActions = {
    add: createAction<MessageData>('messages/add'),
    remove: createAction<string>('messages/remove')
}

export const messageReducer = createReducer(
    initialState,
    (builder) => {
        builder.addCase(messageActions.add, (state, action) => {
            state.messages = [ ... state.messages, Object.assign({ ... defaultMessageData }, { uuid: uuidv4(), ... action.payload })];
        }).addCase(messageActions.remove, (state, action) => {
            state.messages = [ ... state.messages.filter(m => m.uuid !== action.payload) ];
        });
    }
)